import { Divider } from '@outdoorsyco/bonfire';
import React, { HTMLAttributes, useLayoutEffect, useRef, useState } from 'react';

import css from './SectionWithDivider.module.css';

interface IProps extends HTMLAttributes<HTMLElement> {
  divider?: boolean;
  log?: boolean;
}

const SectionWithDivider: React.FC<IProps> = ({ children, divider, className = '', ...props }) => {
  const sectionMargin = !divider ? 'mb-6 md:mb-8' : '';
  const ref = useRef<HTMLDivElement>(null);
  const [visible, setVisible] = useState(true);

  useLayoutEffect(() => {
    if (ref.current && ref.current.childElementCount === 0) {
      setVisible(false); // nothing inside -> don't show divider
    }
  }, []);

  if (!visible) return null;

  return (
    <>
      <section ref={ref} className={`${sectionMargin} ${className} ${css.section}`} {...props}>
        {children}
      </section>
      {divider && <Divider className={'my-6 md:my-8 col-content'} />}
    </>
  );
};

export default SectionWithDivider;
